<template>
  <!-- Edit Point Dialog -->
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card style="width: 600px; max-width: 80vw;">
      <q-card-section>
        <div class="text-h6">Edit Point</div>
      </q-card-section>

      <q-card-section>
        <q-form @submit.prevent="handleSubmit">
          <q-input
            :model-value="formData.name"
            label="Point Name"
            filled
            required
            class="q-mb-md"
            @update:model-value="$emit('update:name', $event)"
          />
          <q-select
            :model-value="formData.brick_class"
            :options="pointBrickClasses"
            label="BRICK Class"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            @update:model-value="$emit('update:brick-class', $event)"
          />
          <q-select
            :model-value="formData.point_type"
            :options="pointTypeOptions"
            label="Point Type"
            filled
            required
            emit-value
            map-options
            class="q-mb-md"
            hint="Select the type of point based on how it connects to the BMS"
            @update:model-value="$emit('update:point-type', $event)"
          />
          <PointUnitSelector
            :model-value="formData.unit_mapping_id"
            :quantity-kind="inferQuantityKind(formData.brick_class)"
            label="QUDT Unit"
            class="q-mb-md"
            @update:model-value="$emit('update:unit-mapping-id', $event)"
          />
        </q-form>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="Cancel" @click="$emit('update:modelValue', false)" />
        <q-btn color="primary" label="Update Point" :loading="saving" @click="handleSubmit" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup>
  import { defineProps, defineEmits } from 'vue';
  import PointUnitSelector from '../PointUnitSelector.vue';

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    pointBrickClasses: {
      type: Array,
      required: true,
    },
    pointTypeOptions: {
      type: Array,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    inferQuantityKind: {
      type: Function,
      required: true,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:name',
    'update:brick-class',
    'update:point-type',
    'update:unit-mapping-id',
    'submit',
  ]);

  const handleSubmit = () => {
    emit('submit');
  };
</script>
